import {
  Award, BadgeCheck, BadgeDollarSign, BadgePercent, Banknote, Calendar, Camera,
  ChartNoAxesCombined, Check, CircleDollarSign, Clapperboard, Clock, Coins, Compass,
  Crown, Diamond, Dumbbell, Eye, Film, Flag, Flame, Gem, Gift, Globe, Handshake,
  Heart, Image as ImageIcon, Instagram, Layers, Leaf, Link as LinkIcon, Lock, Medal,
  Megaphone, MessageCircle, Mic, Mountain, Music, Package, Palette, PartyPopper,
  Percent, Play, Rocket, Send, Shield, ShieldCheck, Shirt, ShoppingBag, ShoppingCart,
  Smartphone, Sparkles, Sprout, Star, Store, Sun, Tag, Target, ThumbsUp, Ticket,
  TrendingUp, Trophy, Truck, Users, Video, Wallet, Wand2, Zap,
  type LucideIcon,
} from "lucide-react";

/**
 * The icons a brand can pick from. A curated map rather than all of lucide:
 * importing the full set by name would pull ~1,500 icons into the bundle, and
 * a wall of them is a worse picker than seventy that suit an affiliate program.
 * Documents store the key, so an entry may be added but never renamed.
 */
export const PAGE_ICONS: Record<string, LucideIcon> = {
  Trophy, Crown, Medal, Award, Star, Gem, Diamond, Sparkles, Flame, Zap, Rocket,
  Target, Flag, Mountain, TrendingUp, ChartNoAxesCombined, Sprout, Leaf, Sun,
  Percent, BadgePercent, BadgeDollarSign, CircleDollarSign, Coins, Banknote, Wallet,
  Gift, PartyPopper, Ticket, Tag, Package, Truck, ShoppingBag, ShoppingCart, Store, Shirt,
  Users, Handshake, Heart, ThumbsUp, MessageCircle, Megaphone, Send, Globe,
  Camera, Video, Film, Clapperboard, Play, Mic, Music, Image: ImageIcon, Instagram,
  Smartphone, Link: LinkIcon, Eye, Palette, Wand2, Layers, Compass, Dumbbell,
  Calendar, Clock, Check, BadgeCheck, Shield, ShieldCheck, Lock,
};

export const PAGE_ICON_NAMES = Object.keys(PAGE_ICONS);
